/* ------------------------------------------ GRYFF ARTICLE SELECTOR - CHRIS 01.12.2016 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import api from '@/app/endpoints.js';
import { GET } from '@/app/api/index';

(function (jQuery) {
  jQuery.gfArticleSelector = function (element, options) {
    const defaults = {
      onSuccess: function () {},
      detectChange: function () {},
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const $aSelector = jQuery(
      '<a id="gf-pick-article" class="button" href="#"><i class="fa fa-crosshairs" aria-hidden="true"></i> Pick an Article</a>',
    );
    const _mdArticleSelector =
      '<div id="md-article-selector" class="md-modal md-draggable"> <div class="md-content"> <div class="md-modal-handle"> <span class="md-title">Pick an Article<span></span></span> </div> <div class="md-tabs-content"> <div class="md-body"> <input type="text" id="search-article" name="search-article" value="" placeholder="Search by article name..." /> <div class="article-list"> <br /> <p class="text-center">Loading articles...</p> <br /> </div> </div> </div> <div class="md-footer"> <button class="btnCancel" class="cancel">Cancel</button> </div> </div> <div class="md-controls"> <button class="btnClose"><i class="fa fa-times" aria-hidden="true"></i></button> </div></div>';
    const $activeModal = jQuery(_mdArticleSelector);

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      if ($element.next('#gf-pick-article').length == 0) {
        $element.after($aSelector);
      }
      this.applyEvents();
    };

    this.getNewestArticles = async function () {
      const $articleList = $activeModal.find('.article-list');
      const shop = $gfFrame.data('gfframe').getShopDomain();
      try {
        params = {
          shop: shop,
          limit: 249,
          fields: 'id,title,handle,summary_html,updated_at,created_at',
        };
        const res = await GET(api.getArticles().url, params);
        const jsonData = res.data;
        const _articles = jsonData['articles'];
        let html = '';
        for (let i = 0; i < _articles.length; i++) {
          html +=
            '<li data-aId="' +
            _articles[i].id +
            '" data-aHandle="' +
            _articles[i].handle +
            '" data-aTitle="' +
            _articles[i].title +
            '">' +
            _articles[i].title +
            '</li>';
        }
        html = '<ul>' + html + '</ul>';

        $articleList.html(html).addClass('optiscroll').optiscroll();

        _this.bindArticleEvents();
      } catch (err) {
        $articleList.css('opacity', '1');
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
      }
    };

    this.searchArticles = async function (s) {
      const $articleList = $activeModal.find('.article-list');
      const shop = $gfFrame.data('gfframe').getShopDomain();

      try {
        const params = {
          shop: shop,
          s: s,
          limit: 249,
        };
        const res = await GET(api.searchArticles().url, params);
        const jsonData = res.data;
        const _articles = jsonData['articles'];
        let html = '';
        for (let i = 0; i < _articles.length; i++) {
          html +=
            '<li data-aId="' +
            _articles[i].id +
            '" data-aHandle="' +
            _articles[i].handle +
            '" data-aTitle="' +
            _articles[i].title +
            '">' +
            _articles[i].title +
            '</li>';
        }
        html = '<ul>' + html + '</ul>';

        $articleList.html(html).addClass('optiscroll').optiscroll();

        _this.bindArticleEvents();
      } catch (err) {
        $articleList.css('opacity', '1');
        HELPER.showNotify('There are some errors occurred please try again. 999', 'error');
      }
    };

    this.applyEvents = function () {
      $aSelector.off('click').on('click', function () {
        const crEditID = $gfLeftSideBar.find('#md-settings').data('edittingID');
        if (crEditID.indexOf('-child') !== -1) {
          HELPER.showNotify("Can't change article", 'error');
          return false;
        }

        $activeModal.appendTo($divContentHidden);
        $activeModal.gfModal({
          onCancel: function () {
            $activeModal.remove();
          },
        });
        // show modal
        $activeModal.data('gfmodal').setWidth('500px').setPosition($gfLeftSideBar.children().innerWidth(), 0).show();

        _this.getNewestArticles();

        let delaySearch;
        $activeModal
          .find('#search-article')
          .off()
          .on('keyup paste', function () {
            clearTimeout(delaySearch);
            const input = jQuery(this).val().trim();
            if (input === '') {
              delaySearch = setTimeout(function () {
                _this.getNewestArticles();
              }, 500);
            } else {
              delaySearch = setTimeout(function () {
                _this.searchArticles(input);
              }, 500);
            }
            return false;
          });
      });

      $element.off('mousedown').on('mousedown', function () {
        $aSelector.trigger('click');
        return false;
      });
    };

    this.bindArticleEvents = function () {
      const $articleList = $activeModal.find('.article-list');
      $articleList
        .find('ul li')
        .off()
        .on('click', function () {
          const articleTitle = jQuery(this).attr('data-aTitle');
          const articleId = jQuery(this).attr('data-aId');
          const articleHandle = jQuery(this).attr('data-aHandle');

          $element.val(articleTitle).trigger('input-change');
          $element.attr('data-value', articleTitle);

          const $aID = $element.parent().siblings('.columns').children('#aId');

          $aID.val(articleId);
          $aID.attr('default-value', articleId);

          const $aHandle = $element.parent().siblings('.columns').children('#aHandle');
          $aHandle.val(articleHandle);
          $aHandle.attr('default-value', articleHandle);

          $element.effect(
            'highlight',
            {
              color: '#afd23e',
            },
            1000,
          );

          $activeModal.data('gfmodal').hide();

          _this.settings.detectChange();
          return false;
        });

      $articleList
        .find('#searchAdvanced')
        .off()
        .on('click', function () {
          return false;
        });
    };

    this.init();
  };

  jQuery.fn.gfArticleSelector = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfarticleselector')) {
        const plugin = new jQuery.gfArticleSelector(this, options);
        jQuery(this).data('gfarticleselector', plugin);
      }
    });
  };
})(jQuery);
